import '../css/main.scss';
import $ from 'jquery';
import 'slick-carousel';

const MAIN = (($) => {

	const $body = $('html, body');

	const sliderInit = () => {
		const $slider = $('.js-slider');
		let options = {
			pauseOnHover: false,
			arrows: false,
			dots: false,
      autoplay: true,
      speed: 1000,
			infinite: true,
      autoplaySpeed: 2500,
      lazyLoad: 'progressive'
		};

		const init = () => $slider.slick(options);

		return init();
	};


	const menuInit = () => {
		const $menu = $('.menu');
		const $menuBtn = $('.header__menu-toggle');
		const $closeBtn = $('.menu__btn-close a');

		const init = () => _bind();

		const _bind = () => {
			$menuBtn.on('click', _showMenu);
			$closeBtn.on('click', _hideMenu);
		};

		const _showMenu = () => $menu.addClass('active');

		const _hideMenu = (e) => {
			e.preventDefault();
			$menu.removeClass('active');
		};

		return init();
	};


	const btnUpInit = () => {
		const $btnUp = $('.footer__btn-up a');

		const init = () => _bind();

		const _bind = () => $btnUp.on('click', _scrollUp);

		const _scrollUp = (e) => {
			e.preventDefault();

			$body.animate({
				scrollTop: 0
			}, 700)
		};

		return init();
	};


	const langDropDown = () => {
		const $footerBtn = $('.footer__lang a');
		const $footerMenu = $('.footer__dropdown-wrap');
		const $overlayBtn = $('.menu__lang a');
		const $overlayMenu = $('.menu__dropdown-wrap');

		const init = () => _bind();

		const _bind = () => {
			$footerBtn.on('click', _menuToggle);
			$overlayBtn.on('click', _menuToggle);
		}

		const _menuToggle = (e) => {
			e.preventDefault();

			if ($(e.target).is($footerBtn)) {
				$footerMenu.slideToggle();
				$footerBtn.parent().toggleClass('active');
			}
			else {
				$overlayMenu.slideToggle();
				$overlayBtn.parent().toggleClass('active');
			}
		}

		return init();
	};


	const anchorInit = () => {
		const $anchor = $('.anchor');
		const $menu = $('.menu');

		const init = () => _bind();

		const _bind = () => $anchor.on('click', _scrollTo);

		const _scrollTo = (e) => {
			let target = $(e.target.hash);

			if (target.length) {
				e.preventDefault();

				_hideMenu();

				$body.animate({
					scrollTop: target.offset().top - 64
				}, 700);
			}
		};

		const _hideMenu = () => {
			$menu.removeClass('active');
		}

		return init();
	};


	const accessGuideInit = () => {
		const $toggleBtn = $('.a-guide__btn a');
		const toggleBtnHeight = $('.a-guide__btn').height();
		const $upBtn = $('.a-guide__btn-up a');

		const init = () => _bind();

		const _bind = () => {
			$toggleBtn.on('click', _tabToggle);
			$upBtn.on('click', _scrollUp);
		};

		const _tabToggle = (e) => {
			e.preventDefault();
			$(e.target).parent().toggleClass('active').next('.a-guide__tab').slideToggle();
		};

		const _scrollUp = (e) => {
			e.preventDefault();
			$body.animate({
				scrollTop: $(e.target).parents('.a-guide__tab').offset().top - toggleBtnHeight
			}, 500);
		};

		return init();
	};





	return {
		init: function init() {
			sliderInit();
			menuInit();
			btnUpInit();
			langDropDown();
			anchorInit();
			accessGuideInit();
		}
	};
})($);


$(() => { MAIN.init(); });


